import { useEffect } from 'react';
import { ROLE_CANDIDATE, ROLE_CANDIDATE_EPG, URL_DOMAIN_EPG, URL_DOMAIN_PREG } from 'utils/ConstantsAndNum';

interface UseDomainValidationReturn {
  isEPGDomain: boolean;
  isPREGDomain: boolean;
  isLocalhost: boolean;
  isValidRoleForDomain: boolean;
  allowedRole: string | undefined;
}

const useDomainValidation = (userRole: string | undefined): UseDomainValidationReturn => {
  const hostname = window.location.hostname;

  const domainConfig = {
    epg: {
      domains: [URL_DOMAIN_EPG],
      role: ROLE_CANDIDATE_EPG.toUpperCase()
    },
    preg: {
      domains: [URL_DOMAIN_PREG],
      role: ROLE_CANDIDATE.toUpperCase()
    },
    local: {
      domains: ["localhost", "127.0.0.1"],
      roles: [ROLE_CANDIDATE.toUpperCase(), ROLE_CANDIDATE_EPG.toUpperCase()]
    }
  };

  const isEPGDomain = domainConfig.epg.domains.includes(hostname);
  const isPREGDomain = domainConfig.preg.domains.includes(hostname);
  const isLocalhost = domainConfig.local.domains.includes(hostname);

  const isValidRoleForDomain =
    (isEPGDomain && userRole === domainConfig.epg.role) ||
    (isPREGDomain && userRole === domainConfig.preg.role) ||
    (isLocalhost && domainConfig.local.roles.includes(userRole || ""));

  const allowedRole = isLocalhost
    ? userRole
    : (isEPGDomain ? domainConfig.epg.role : domainConfig.preg.role);

  useEffect(() => {
    if (isEPGDomain) {
      const link = document.querySelector("link[rel*='icon']") as HTMLLinkElement || document.createElement('link');
      link.type = 'image/x-icon';
      link.rel = 'icon';
      link.href = '/favicon-epg.ico';
      document.getElementsByTagName('head')[0].appendChild(link);
    }
  }, [isEPGDomain]);

  return {
    isEPGDomain,
    isPREGDomain,
    isLocalhost,
    isValidRoleForDomain,
    allowedRole
  };
};

export default useDomainValidation;
